import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(
  (theme, responsive, safeAreaInsets) => ({
    container: {
      pointerEvents: 'box-none',
      alignSelf: 'center',
      position: 'absolute',
      top: safeAreaInsets.top + (responsive.isMobile ? spacing.xs : spacing.l),
      marginHorizontal: spacing.l,
      zIndex: 10000,
      justifyContent: 'center',
      alignItems: 'center',
      gap: spacing.xs,
    },
  }),
);
